import React from 'react'
import { Link } from 'react-router-dom'
import { AddToWishlist, ProductPrice } from 'lib/modules/catalog'
import { WishlistItem, Image, AddToWishlistContainer } from '../Styled'
import { ProductData } from 'lib/types'

interface Props {
  product: ProductData
}

export const Item = ({ product }: Props) => {
  const {
    name,
    price,
    image,
    sku,
    urlKey,
    typeName
  } = product

  const imageUrl = image?.default.url
  return (
    <WishlistItem>
      <AddToWishlistContainer>
        <AddToWishlist
          sku={sku}
        />
      </AddToWishlistContainer>
      <Link
        to={`/${urlKey}`}
      >
        <Image>
          <span
            style={{ backgroundImage: `url(${imageUrl})` }}
          />
        </Image>
        <div className='title'>
          {name}
        </div>
        <div className='price'>
          <ProductPrice
            price={price}
            type={typeName}
          />
        </div>
      </Link>
    </WishlistItem>
  )
}
